import { error as showErrorToast } from '@/plugins/toast';

const E401_LOGOUT_REASONS = {
  session_replaced: 'Login em outro dispositivo',
  admin_logout: 'Por um gestor da conta',
  inactivity_timeout: 'Por inatividade',
};

export default (http, { router, store }) => {
  http.interceptors.response.use(
    response => response,
    (error) => {
      if (error.response) {
        const { status, data = {} } = error.response;
        if (status === 401) {
          if (data.reason === 'sessionInactive') {
            let message = 'Sua sessão foi encerrada';
            if (data.logoutReason && data.logoutReason in E401_LOGOUT_REASONS) {
              message += ` (${E401_LOGOUT_REASONS[data.logoutReason]})`;
            }
            showErrorToast(message);
            error.response.data.message = message;
          }

          store.dispatch('resetAuthState');

          if (!['/auth', '/logout'].includes(error.config.url)) {
            router.push({ path: '/login' });
          }
        } else if (status === 403) {
          const message = 'Acesso negado';
          showErrorToast(message);
          error.response.data.message = message;
        }
      }

      return Promise.reject(error);
    },
  );
};
